import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const CaseSellerReasonForSale1 = union([
    literal("normal"),
    literal("repossession"),
    literal("probate"),
    literal("probate_as1"),
    literal("probate_djp"),
    literal("probate_concessionary"),
    literal("deputyship"),
    literal("divorce"),
    literal("unknown"),
]);
export type TCaseSellerReasonForSale1Codec = typeof CaseSellerReasonForSale1;
export type TCaseSellerReasonForSale1 = TTypeOfCodec<typeof CaseSellerReasonForSale1>;

// The four probate reasons. An estate sale by a personal representative is
// near-always sold under limited title guarantee (see
// docs/adr/0004-limited-title-pif-auto-answers.md) and covers the whole of the
// registered title, so selecting any of these defaults the property's
// title_guarantee/transfer_of (see CONTEXT.md §618).
export const probateSellerReasonsForSale: ReadonlyArray<TCaseSellerReasonForSale1> = [
    "probate",
    "probate_as1",
    "probate_djp",
    "probate_concessionary",
];

export const isProbateSellerReasonForSale = (
    reason: TCaseSellerReasonForSale1,
): boolean => probateSellerReasonsForSale.includes(reason);

// The probate reasons that name a specific HMLR route rather than a plain estate sale. On a
// transfer these make an application to HMLR, so the death certificate evidences the death. The
// will is NOT keyed off this set: every probate transfer needs one, bare reason included, because
// a bare "probate" on a transfer only means nobody picked the route (see
// probate/probateDocumentRequirements.ts).
export const qualifiedProbateSellerReasonsForSale: ReadonlyArray<TCaseSellerReasonForSale1> = [
    "probate_as1",
    "probate_djp",
    "probate_concessionary",
];

export const isQualifiedProbateSellerReasonForSale = (
    reason: TCaseSellerReasonForSale1,
): boolean => qualifiedProbateSellerReasonsForSale.includes(reason);

